import { deepMerge } from '@antfu/utils'
import { ServiceProvider } from '@quasarcast/vue-service'
import makeSqliteStorer from 'services/storage/local/makeSqliteStorer'
import { Network } from '@capacitor/network'
import stringSerializer from 'src/shared/serializers/stringSerializer'
import { readFuelloxAuthToken } from 'src/auth/readFuelloxAuthToken'

export const userConfigServiceProvider: ServiceProvider = {
  /**
   * Register any services by adding them to app
   */
  register: async ({ config, styles, settings, app }) => {
    const tokenStorer = makeSqliteStorer('fuellox', 'fuelloxToken', undefined, stringSerializer)
    const tenantIdStorer = makeSqliteStorer('fuellox', 'tenantId', undefined, stringSerializer)
    const orgIdStorer = makeSqliteStorer('fuellox', 'orgId', undefined, stringSerializer)

    const token = await readFuelloxAuthToken(() => tokenStorer.get())
    const tenantId = await tenantIdStorer.get()
    const orgId = await orgIdStorer.get()

    const userConfigStorer = makeSqliteStorer('fuellox', 'userConfigStorer')

    const status = await Network.getStatus()

    if (token && tenantId && orgId && status.connected) {
      // TODO: when fetching configs from the backend, some of the objects are a string of "[object Object]".
      // We need to fix that before commenting this code back in.

      // let response: any
      // try {
      //   response = await fetch(process.env.CORE_API_URL + '/api/merged-configs', {
      //     method: 'get',
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //       'tenant-id': tenantId,
      //       'org-id': orgId,
      //       Accept: 'application/json',
      //     },
      //   })
      // } catch {
      //   return
      // }

      // let responseData

      // try {
      //   responseData = await response.json()
      //   userConfigStorer.set(responseData)
      // } catch {
      //   return
      // }

      // styles = deepMerge(styles, responseData.styles)
      // config = deepMerge(config, responseData.config)
      // settings = deepMerge(settings, responseData.settings)
    } else if (!status.connected) {
      const rawUserConfig = await userConfigStorer.get()
      if (rawUserConfig) {
        try {
          const userConfig = JSON.parse(rawUserConfig)
          styles = deepMerge(styles, userConfig.styles)
          config = deepMerge(config, userConfig.config)
          settings = deepMerge(settings, userConfig.settings)
        } catch (err) {
          console.error('error merging user config from local storage')
          console.error(err)
        }
      }
    }
  },
}
